import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
// import video from "../assets/videos/developer.mp4";

const Hero = () => {
  const [playVideo, setPlayVideo] = useState(false);
  useEffect(() => {
    setPlayVideo(true);
  }, [2000]);

  return (
    <>
      <div id="react-player-value" className="position-relative">
        <ReactPlayer
          className="react-player"
          url="https://vz-e28eac45-f0a.b-cdn.net/b3b383b6-4422-4527-b585-f59342dcdea7/playlist.m3u8"
          width="100%"
          playing={true}
          loop={true}
          muted={true}
          height="100%"
        />
        {/* <video width="100%" height="100%" controls autoPlay loop muted>
          <source src={video} type="video/mp4" />
        </video> */}

        <div className="position-absolute bottom-0 w-100 h-100  d-flex justify-content-sm-end justify-content-center flex-column">
          <div className="pb-sm-5 mb-sm-5 container">
            <h1
              className="text-white text-sm-start text-center"
              data-aos="fade-right"
              data-aos-delay="400"
              data-aos-duration="1200">
              THE SAFE SHIELD
            </h1>
            <p
              data-aos="fade-right"
              data-aos-delay="800"
              data-aos-duration="1200"
              className="text-white text-sm-start text-center">
              Securing Our Beloved Qatar’s Vital Infrastructure
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
